import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Input } from "@arco-design/web-react";
import { EmojiClickData } from "emoji-picker-react";
import { RefTextAreaType } from "@arco-design/web-react/es/Input/textarea";

import IconFace from "../../../../../../assets/icons/IconFace";
import {  MAX_COMMENT_LENGTH } from "../../constants";
import { EmojiPickerModal } from "../../../../../../components/EmojiPickerModal/EmojiPickerModal";
import { PostApi } from "../../types/types";
import { getButtonColor } from "../../../../../../utils/cssVariables";

import './CommentInput.css'
import { useBreakpoint } from "../../../../../../utils/hooks";
import { IconSend } from "@arco-design/web-react/icon";

interface ICommentInputProps {
  post: PostApi;
  isMutating: boolean;
  onAddComment: (post: PostApi, newComment: string) => void;
}

const CommentInput = ({
  post,
  isMutating,
  onAddComment,
}: ICommentInputProps) => {
  const { t } = useTranslation();
  const { isMobile } = useBreakpoint('mobile');

  const [newComment, setNewComment] = useState<string>("");

  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const contentInputRef = useRef<RefTextAreaType>(null);

  const handleEmojiClick = (emojiData: EmojiClickData) => {
    setNewComment(prev => prev + emojiData.emoji);
    setShowEmojiPicker(false);

    contentInputRef.current?.focus();
  };

  const toggleEmojiPicker = () => {
    setShowEmojiPicker(!showEmojiPicker);
  };

  const handleSubmit = () => {
    onAddComment(post, newComment);
    setNewComment("");
  };

  return (
    <div className="comment-input__wrapper">
      <div className="comment-input__actions">
        <div className="comment-input__input">
          <Input.TextArea
            ref={contentInputRef}
            value={newComment}
            onChange={setNewComment}
            placeholder={t('home_page.add_comment_input')}
            autoSize
            showWordLimit={!isMobile}
            maxLength={MAX_COMMENT_LENGTH}
          />
        </div>

        <Button
          className="comment-input__action-button"
          onClick={toggleEmojiPicker}
        >
          <IconFace className="comment-input__action-button-icon" />
        </Button>
      </div>
      
      <Button
        onClick={() => handleSubmit()}
        style={{
          backgroundColor: getButtonColor(),
        }}
        size="small"
        type="primary"
        shape="round"
        disabled={isMutating}
      >
        <IconSend />
      </Button>

      <EmojiPickerModal
        visible={showEmojiPicker}
        onClose={() => setShowEmojiPicker(false)}
        onEmojiClick={handleEmojiClick}
      />
    </div>
  );
};

export default CommentInput;
